import React from 'react';
import parse from 'html-react-parser';

import './style.sass';

const CommonOlList = ({
    CommonOlList: { colorNumber, big = false, bignormal = false, list },
    className = '',
}) => {
    return (
        <ul className={`common__ol-list ${className}`}>
            {list.map((item, index) => {
                return (
                    <li
                        className={`common__ol-item ${big && 'common__ol-item--big'} ${
                            bignormal && 'common__ol-item--big-normal'
                        }`}
                        key={index}
                    >
                        <span
                            className={`common__ol-number ${big && 'common__ol-number--big'}`}
                            style={{ color: colorNumber }}
                        >
                            {++index}.
                        </span>
                        <span className="common__ol-info">{parse(item)}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export default CommonOlList;
